export default "__VITE_ASSET__PtA5q0LI__"